export const CARD_PRODUCTS = [
    { name: '1C' },
    { name: '3C' },
    { name: '3C4C' }
];